import { render, staticRenderFns } from "./AdminRecords.vue?vue&type=template&id=38e3023f&scoped=true&"
import script from "./AdminRecords.vue?vue&type=script&lang=js&"
export * from "./AdminRecords.vue?vue&type=script&lang=js&"
import style0 from "./AdminRecords.vue?vue&type=style&index=0&id=38e3023f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e3023f",
  null
  
)

export default component.exports